import CompareBasketMobile from './CompareBasketMobile'

export default CompareBasketMobile
